import { render } from "./message_set.vue?vue&type=template&id=33b23f82&scoped=true"
import script from "./message_set.vue?vue&type=script&lang=js"
export * from "./message_set.vue?vue&type=script&lang=js"

import "./message_set.vue?vue&type=style&index=0&id=33b23f82&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b23f82"]])

export default __exports__